'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const EmailSingleIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="EmailSingleIcon">
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        id="Email-Action-Unread--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Email Action Unread Streamline Icon: https://streamlinehq.com</desc>
        <path
          d="m0.5 3.954 23 0 0 16 -23 0Z"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M22.911 4.536 12 13.454 1.089 4.536"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

EmailSingleIcon.propTypes = {
  sx: PropTypes.object
}
